import { Directive } from '@angular/core';

// Marks the icon an activity list item pins to its avatar, e.g.
// <i scActivityIcon class="fa-sharp fa-solid fa-user-plus"></i>
@Directive({
    selector: '[scActivityIcon]',
    standalone: false
})
export class ActivityIconDirective { }
